import { Observable, Subscriber } from 'rxjs';
import { execIfDefined } from '../../core/utils/exec-if-defined';
import { AppConfig } from '../../core/app.config';
import { BACKGROUND_NETWORK_REQ_OPTIONS } from '../../core/constants/constants';
import { SupportService } from '../interfaces/support';
import { RxRequestService } from '../../core/services/rx-request.service';

declare const zE: any;
declare const __ZENDESK_KEY__: string;

export class ZendeskService extends SupportService {
  static deps = [AppConfig, RxRequestService];

  unreadCount$ = new Observable((subscriber: Subscriber<number>) => {
    execIfDefined('zE', () => {
      zE('messenger:on', 'unreadMessages', function (unreadCount: number) {
        subscriber.next(unreadCount);
      });
    });
  });

  constructor(protected _appConfig: AppConfig, protected _rxRequestService: RxRequestService) {
    super(_appConfig, _rxRequestService);

    execIfDefined('zE', () => {
      zE('messenger:on', 'open', () => {
        this._liveChatIsOpen$.next(true);
      });
    });

    execIfDefined('zE', () => {
      zE('messenger:on', 'close', () => {
        this._liveChatIsOpen$.next(false);
      });
    });
  }

  show(body?: string) {
    if (typeof zE === 'undefined' || typeof __ZENDESK_KEY__ === 'undefined' || !__ZENDESK_KEY__) {
      window.open(this.supportLink, '_blank');

      return;
    }

    execIfDefined('zE', () => {
      if (body) {
        zE('messenger', 'open');
        return;
      }

      zE('messenger', 'open');
    });
  }

  hide() {
    execIfDefined('zE', () => {
      zE('messenger', 'close');
    });
  }

  resetSupportService() {
    execIfDefined('zE', () => {
      zE('messenger', 'logoutUser');
    });

    execIfDefined('zE', () => {
      zE('messenger', 'resetWidget');
    });

    this.showDefaultLauncher();
  }

  hideDefaultLauncher() {
    document.querySelector('#zendesk_default_launcher')?.classList.add('d-none');
  }

  showDefaultLauncher() {
    document.querySelector('#zendesk_default_launcher')?.classList.remove('d-none');
  }

  updateSupportServiceContext(initial: boolean) {
    if (initial) {
      execIfDefined('zE', () => {
        zE(
          'messenger',
          'loginUser',
          (callback: (token: string) => void) => {
            this._rxRequestService
              .get(
                `${this._appConfig.getSecurityServiceURL()}/oauth/zendesk/jwt-token`,
                BACKGROUND_NETWORK_REQ_OPTIONS
              )
              .toPromise()
              .then(res => {
                callback(res.jwt_token);
              });
          },
          function loginCallback(error) {
            if (error) {
              console.log(error);
            }
          }
        );
      });
    }
  }
}
